module.exports = __webpack_public_path__ + "static/img/gfyh.a0201079.png";